module.exports = __webpack_public_path__ + "static/img/app-feat-phone.17f29a89.png";